<!-- 列表单元格 -->
<template>
  <div class="teas-cell-item mobile">
    <!-- <slot name="icon">
      <i v-if="icon" class="teas-cell-item-icon" :class="['iconfont', icon]"></i>
    </slot>
    <slot name="label">
      <span v-if="label" class="teas-cell-item-label">
        {{ label }}
      </span>
    </slot>
    <slot name="value">
      <span class="teas-cell-item-value">{{ value }}</span>
    </slot> -->
    <div class="cell-item-left" v-if="icon || label">
      <slot name="icon">
        <i v-if="icon" class="teas-cell-item-icon" :class="['iconfont', icon]"></i>
      </slot>
      <slot name="label">
        <span v-if="label" class="teas-cell-item-label">
          {{ label }}
        </span>
      </slot>
    </div>
    <slot name="value">
      <div :class="['teas-cell-item-value', valueClass]">{{ value }}</div>
    </slot>
  </div>
</template>

<script>
// 数据格式案例
const testData = {
  label: "名字：",
  value: "张三",
  icon: "icon-yzkb", // icon的name
};

export default dsf.component({
  name: "DsfMobileTeasCellItem",
  ctrlCaption: "列表单元格的列表item",
  mixins: [$mixins.control],
  design: {},
  props: {
    // label
    label: {
      type: String,
      default: "",
    },
    // value
    value: {
      type: String,
      default: "",
    },
    // icon
    icon: {
      type: String,
      default: "",
    },
    // value几行显示
    valueEllipsis: {
      type: Number,
      default: 0, // 默认无限制
    },
  },
  data() {
    return {};
  },
  computed: {
    valueClass() {
      switch (this.valueEllipsis) {
        case 1:
          return "van-ellipsis";
        case 2:
          return "van-multi-ellipsis--l2";
        case 3: 
          return "van-multi-ellipsis--l3";
        default:
          return "";
      }
    },
  },
  created() {},
  mounted() {},
  methods: {},
});
</script>
